import { ProjectMethodologyEnum } from 'gql/graphql';

import { useMemo } from 'react';

import { useBimWorkOrderVersionsItems } from './useBimWorkOrderVersionsItems';
import { useUerWorkOrderVersionsItems } from './useUerWorkOrderVersionsItems';

export const useGetVersionItems = (workOrderChangeId: number, methodology: ProjectMethodologyEnum | undefined) => {
    const bimVersionsItems = useBimWorkOrderVersionsItems(
        workOrderChangeId,
        Boolean(methodology && methodology === ProjectMethodologyEnum.Bim),
    );

    const uerVersionsItems = useUerWorkOrderVersionsItems(
        workOrderChangeId,
        Boolean(methodology && methodology === ProjectMethodologyEnum.Uer),
    );

    return useMemo(() => {
        if (methodology === ProjectMethodologyEnum.Bim) {
            return bimVersionsItems;
        }

        if (methodology === ProjectMethodologyEnum.Uer) {
            return uerVersionsItems;
        }

        return [];
    }, [bimVersionsItems, methodology, uerVersionsItems]);
};
